import React, { useState } from 'react'
import "./WorkTeam.scss"
import person from "../../Assets/user.png"
import { IoCheckmarkSharp } from "react-icons/io5";
import { CiCalendarDate } from "react-icons/ci";
import { IoTimerSharp } from 'react-icons/io5';
import { IoMdPrint } from "react-icons/io";
import { CiEdit } from "react-icons/ci";
import { MdOutlineDelete } from "react-icons/md";

import { LiaStarSolid } from "react-icons/lia";

export default function WorkTeam() {
  const [activeRow, setActiveRow] = useState(null);

  const toggleDetails = (index) => {
    setActiveRow(activeRow === index ? null : index);
  };

  return (
    <div className='work-team p-3'>
            <h4 className='address'>Work team account</h4>

      <div className='team mb-4'>

        {/* Member Info */}
        <div className='member-info'>
          <img src={person} alt="person" />
          <div>
            <h6 className='name'>Mr Osama Ali</h6>
            <div className="role-status">
              <span className="role">HR</span>
              <span className="succfull"><IoCheckmarkSharp /></span>
            </div>
          </div>
        </div>

        {/* Info Boxes */}
        <div className='info-box'>
          <p className='label'>Start Date</p>
          <div className='info-content'><CiCalendarDate /><span>25/5/2025</span></div>
        </div>

        <div className='info-box'>
          <p className='label'>Live Working Time</p>
          <div className='working-time'><IoTimerSharp /><span>00:30:00</span></div>
        </div>

        <div className='info-box'>
          <p className='label'>Last Activity</p>
          <div className='info-content'><CiCalendarDate /><span>25/5/2025</span></div>
        </div>

        <div className='info-box'>
          <p className='label'>Join Date</p>
          <div className='info-content'><CiCalendarDate /><span>25/5/2025</span></div>
        </div>

       
        <div>
          <span className="order-details" onClick={() => toggleDetails(0)}>...</span>
        </div>
          {activeRow === 0 && (
        <table className="details-table container mx-auto" style={{ width: "100%", marginTop: "20px", borderCollapse: "collapse" }}>
          <thead style={{  marginTop: "20px", borderBottom:"1px solid #f6f6f6" }}>
            <tr style={{ color: "#999999", textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Full Name</td>
              <td style={{ padding: "10px" }}>PHONE</td>
              <td style={{ padding: "10px" }}>EMAIL</td>
              <td style={{ padding: "10px" }}>COUNTRY</td>
              <td style={{ padding: "10px" }}>DATE</td>
              <td style={{ padding: "10px" }}>Time</td>
              <td style={{ padding: "10px", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                <IoMdPrint style={{ fontSize: "20px" }} />
                Print
              </td>
            </tr>
          </thead>
          <tbody style={{ backgroundColor: "white", textAlign: "center" , borderBottom:"1px solid #f6f6f6"}}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>Osama Ali alabyaare</td>
              <td style={{ padding: "10px" }}>+20 1012345678</td>
              <td style={{ padding: "10px" }}>osama@email.com</td>
              <td style={{ padding: "10px" }}>Egypt</td>
              <td style={{ padding: "10px" }}>12/12/23</td>
              <td style={{ padding: "10px" }}>12:00 PM</td>
              {/* <td style={{ padding: "10px" }}>12:00 PM</td> */}
            </tr>
          </tbody>

          {/* إذا تريد تكرار نفس الجدول (مثل ما في كودك مرتين) فقط انسخ الـ <thead> و <tbody> مرة ثانية */}
          <thead style={{  marginTop: "20px", borderBottom:"1px solid #f6f6f6" }}>
            <tr style={{ color: "#999999", textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Full Name</td>
              <td style={{ padding: "10px" }}>PHONE</td>
              <td style={{ padding: "10px" }}>EMAIL</td>
              <td style={{ padding: "10px" }}>COUNTRY</td>
              <td style={{ padding: "10px" }}>DATE</td>
              <td style={{ padding: "10px" }}>Time</td>
              <td style={{ padding: "10px" }}>Print</td>
            </tr>
          </thead>
          <tbody style={{ backgroundColor: "white", textAlign: "center" , borderBottom:"1px solid #f6f6f6"}}>
            <tr>
              <td style={{ padding: "10px"}}>Osama Ali alabyaare</td>
              <td style={{ padding: "10px" }}>+20 1012345678</td>
              <td style={{ padding: "10px" }}>osama@email.com</td>
              <td style={{ padding: "10px" }}>Egypt</td>
              <td style={{ padding: "10px" }}>12/12/23</td>
              <td style={{ padding: "10px" }}>12:00 PM</td>
              <td style={{ padding: "10px" }}>12:00 PM</td>
            </tr>
          </tbody>
        </table>
      )}


    {activeRow === 0 && (
  <table className="details-table container mx-auto" style={{ width: "100%", marginTop: "20px", borderCollapse: "collapse" }}>
    <thead> 
      <tr style={{ color: "black", width:"100%" }}>
        <th colSpan={12} style={{ padding: "10px", textAlign: "center" ,backgroundColor:"#f6f6f6"}}>
          Performance
        </th>
      </tr>
    </thead>


       <thead >
            <tr style={{  textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Performance</td>
              <td style={{ padding: "10px" }}>Level</td>
              <td style={{ padding: "10px" }}>Commitment</td>
              <td style={{ padding: "10px" }}>Behavior</td>
              <td style={{ padding: "10px" }}>Evaluation</td>
              <td style={{ padding: "10px" }}>Actions</td>
            
            </tr>
          </thead>
      <tbody style={{ backgroundColor:"#f6f6f6", textAlign: "center" }}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>average</td>
              <td style={{ padding: "10px" }}>admin</td>
              <td style={{ padding: "10px" }}>very good</td>
              <td style={{ padding: "10px" }}>very good

</td>
              <td style={{ padding: "10px" }}><LiaStarSolid  style={{
                color:"yellow"
              }}/>
<LiaStarSolid   style={{
                color:"yellow"
              }}/>
<LiaStarSolid />
<LiaStarSolid /></td>

    <td style={{ padding: "10px" }}><CiEdit style={{
      fontSize:"20px",
      marginRight:"10px"
    }}/>
<MdOutlineDelete    style={{
      fontSize:"20px"
    }}/>

          </td>
             
            </tr>
          </tbody>

      <thead >
            <tr style={{  textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Projects</td>
              <td style={{ padding: "10px" }}>Developments</td>
              <td style={{ padding: "10px" }}>Promotion</td>
              <td style={{ padding: "10px" }}>Notifications</td>
              <td style={{ padding: "10px" }}>Extra time</td>
              <td style={{ padding: "10px" }}>Actions</td>
            
            </tr>
          </thead>
         <tbody style={{ backgroundColor:"#f6f6f6", textAlign: "center" }}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>0</td>
              <td style={{ padding: "10px" }}>0</td>
              <td style={{ padding: "10px" }}>No</td>
              <td style={{ padding: "10px" }}>2

</td>
              <td style={{ padding: "10px" }}>7 H</td>

    <td style={{ padding: "10px" }}><CiEdit style={{
      fontSize:"20px",
      marginRight:"10px"
    }}/>
<MdOutlineDelete    style={{
      fontSize:"20px"
    }}/>

          </td>
             
            </tr>
          </tbody>






           <thead >
            <tr style={{  textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Asbence</td>
              <td style={{ padding: "10px" }}>Delay</td>
              <td style={{ padding: "10px" }}>Permission</td>
              <td style={{ padding: "10px" }}>Deduct</td>
              <td style={{ padding: "10px" }}>Bonus</td>
              <td style={{ padding: "10px" }}>Actions</td>
            
            </tr>
          </thead>
         <tbody style={{ backgroundColor:"#f6f6f6", textAlign: "center" }}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>0</td>
              <td style={{ padding: "10px" }}>0</td>
              <td style={{ padding: "10px" }}>2</td>
              <td style={{ padding: "10px" }}>2

</td>
              <td style={{ padding: "10px" }}>1</td>

    <td style={{ padding: "10px" }}><CiEdit style={{
      fontSize:"20px",
      marginRight:"10px"
    }}/>
<MdOutlineDelete    style={{
      fontSize:"20px"
    }}/>

          </td>
             
            </tr>
          </tbody>
  </table>
)}










      </div>
  <div className='team mb-4'>

        {/* Member Info */}
        <div className='member-info'>
          <img src={person} alt="person" />
          <div>
            <h6 className='name'>Mr Osama Ali</h6>
            <div className="role-status">
              <span className="role">HR</span>
              <span className="succfull"><IoCheckmarkSharp /></span>
            </div>
          </div>
        </div>

        {/* Info Boxes */}
        <div className='info-box'>
          <p className='label'>Start Date</p>
          <div className='info-content'><CiCalendarDate /><span>25/5/2025</span></div>
        </div>

        <div className='info-box'>
          <p className='label'>Live Working Time</p>
          <div className='working-time'><IoTimerSharp /><span>00:30:00</span></div>
        </div>

        <div className='info-box'>
          <p className='label'>Last Activity</p>
          <div className='info-content'><CiCalendarDate /><span>25/5/2025</span></div>
        </div>

        <div className='info-box'>
          <p className='label'>Join Date</p>
          <div className='info-content'><CiCalendarDate /><span>25/5/2025</span></div>
        </div>

       
        <div>
          <span className="order-details" onClick={() => toggleDetails(0)}>...</span>
        </div>
          {activeRow === 0 && (
        <table className="details-table container mx-auto" style={{ width: "100%", marginTop: "20px", borderCollapse: "collapse" }}>
          <thead style={{  marginTop: "20px", borderBottom:"1px solid #f6f6f6" }}>
            <tr style={{ color: "#999999", textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Full Name</td>
              <td style={{ padding: "10px" }}>PHONE</td>
              <td style={{ padding: "10px" }}>EMAIL</td>
              <td style={{ padding: "10px" }}>COUNTRY</td>
              <td style={{ padding: "10px" }}>DATE</td>
              <td style={{ padding: "10px" }}>Time</td>
              <td style={{ padding: "10px", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                <IoMdPrint style={{ fontSize: "20px" }} />
                Print
              </td>
            </tr>
          </thead>
          <tbody style={{ backgroundColor: "white", textAlign: "center" , borderBottom:"1px solid #f6f6f6"}}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>Osama Ali alabyaare</td>
              <td style={{ padding: "10px" }}>+20 1012345678</td>
              <td style={{ padding: "10px" }}>osama@email.com</td>
              <td style={{ padding: "10px" }}>Egypt</td>
              <td style={{ padding: "10px" }}>12/12/23</td>
              <td style={{ padding: "10px" }}>12:00 PM</td>
              {/* <td style={{ padding: "10px" }}>12:00 PM</td> */}
            </tr>
          </tbody>

          {/* إذا تريد تكرار نفس الجدول (مثل ما في كودك مرتين) فقط انسخ الـ <thead> و <tbody> مرة ثانية */}
          <thead style={{  marginTop: "20px", borderBottom:"1px solid #f6f6f6" }}>
            <tr style={{ color: "#999999", textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Full Name</td>
              <td style={{ padding: "10px" }}>PHONE</td>
              <td style={{ padding: "10px" }}>EMAIL</td>
              <td style={{ padding: "10px" }}>COUNTRY</td>
              <td style={{ padding: "10px" }}>DATE</td>
              <td style={{ padding: "10px" }}>Time</td>
              <td style={{ padding: "10px" }}>Print</td>
            </tr>
          </thead>
          <tbody style={{ backgroundColor: "white", textAlign: "center" , borderBottom:"1px solid #f6f6f6"}}>
            <tr>
              <td style={{ padding: "10px"}}>Osama Ali alabyaare</td>
              <td style={{ padding: "10px" }}>+20 1012345678</td>
              <td style={{ padding: "10px" }}>osama@email.com</td>
              <td style={{ padding: "10px" }}>Egypt</td>
              <td style={{ padding: "10px" }}>12/12/23</td>
              <td style={{ padding: "10px" }}>12:00 PM</td>
              <td style={{ padding: "10px" }}>12:00 PM</td>
            </tr>
          </tbody>
        </table>
      )}


    {activeRow === 0 && (
  <table className="details-table container mx-auto" style={{ width: "100%", marginTop: "20px", borderCollapse: "collapse" }}>
    <thead> 
      <tr style={{ color: "black", width:"100%" }}>
        <th colSpan={12} style={{ padding: "10px", textAlign: "center" ,backgroundColor:"#f6f6f6"}}>
          Performance
        </th>
      </tr>
    </thead>


       <thead >
            <tr style={{  textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Performance</td>
              <td style={{ padding: "10px" }}>Level</td>
              <td style={{ padding: "10px" }}>Commitment</td>
              <td style={{ padding: "10px" }}>Behavior</td>
              <td style={{ padding: "10px" }}>Evaluation</td>
              <td style={{ padding: "10px" }}>Actions</td>
            
            </tr>
          </thead>
      <tbody style={{ backgroundColor:"#f6f6f6", textAlign: "center" }}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>average</td>
              <td style={{ padding: "10px" }}>admin</td>
              <td style={{ padding: "10px" }}>very good</td>
              <td style={{ padding: "10px" }}>very good

</td>
              <td style={{ padding: "10px" }}><LiaStarSolid  style={{
                color:"yellow"
              }}/>
<LiaStarSolid   style={{
                color:"yellow"
              }}/>
<LiaStarSolid />
<LiaStarSolid /></td>

    <td style={{ padding: "10px" }}><CiEdit style={{
      fontSize:"20px",
      marginRight:"10px"
    }}/>
<MdOutlineDelete    style={{
      fontSize:"20px"
    }}/>

          </td>
             
            </tr>
          </tbody>

      <thead >
            <tr style={{  textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Projects</td>
              <td style={{ padding: "10px" }}>Developments</td>
              <td style={{ padding: "10px" }}>Promotion</td>
              <td style={{ padding: "10px" }}>Notifications</td>
              <td style={{ padding: "10px" }}>Extra time</td>
              <td style={{ padding: "10px" }}>Actions</td>
            
            </tr>
          </thead>
         <tbody style={{ backgroundColor:"#f6f6f6", textAlign: "center" }}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>0</td>
              <td style={{ padding: "10px" }}>0</td>
              <td style={{ padding: "10px" }}>No</td>
              <td style={{ padding: "10px" }}>2

</td>
              <td style={{ padding: "10px" }}>7 H</td>

    <td style={{ padding: "10px" }}><CiEdit style={{
      fontSize:"20px",
      marginRight:"10px"
    }}/>
<MdOutlineDelete    style={{
      fontSize:"20px"
    }}/>

          </td>
             
            </tr>
          </tbody>






           <thead >
            <tr style={{  textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Asbence</td>
              <td style={{ padding: "10px" }}>Delay</td>
              <td style={{ padding: "10px" }}>Permission</td>
              <td style={{ padding: "10px" }}>Deduct</td>
              <td style={{ padding: "10px" }}>Bonus</td>
              <td style={{ padding: "10px" }}>Actions</td>
            
            </tr>
          </thead>
         <tbody style={{ backgroundColor:"#f6f6f6", textAlign: "center" }}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>0</td>
              <td style={{ padding: "10px" }}>0</td>
              <td style={{ padding: "10px" }}>2</td>
              <td style={{ padding: "10px" }}>2

</td>
              <td style={{ padding: "10px" }}>1</td>

    <td style={{ padding: "10px" }}><CiEdit style={{
      fontSize:"20px",
      marginRight:"10px"
    }}/>
<MdOutlineDelete    style={{
      fontSize:"20px"
    }}/>

          </td>
             
            </tr>
          </tbody>
  </table>
)}










      </div>

  <div className='team'>

        {/* Member Info */}
        <div className='member-info'>
          <img src={person} alt="person" />
          <div>
            <h6 className='name'>Mr Osama Ali</h6>
            <div className="role-status">
              <span className="role">HR</span>
              <span className="succfull"><IoCheckmarkSharp /></span>
            </div>
          </div>
        </div>

        {/* Info Boxes */}
        <div className='info-box'>
          <p className='label'>Start Date</p>
          <div className='info-content'><CiCalendarDate /><span>25/5/2025</span></div>
        </div>

        <div className='info-box'>
          <p className='label'>Live Working Time</p>
          <div className='working-time'><IoTimerSharp /><span>00:30:00</span></div>
        </div>

        <div className='info-box'>
          <p className='label'>Last Activity</p>
          <div className='info-content'><CiCalendarDate /><span>25/5/2025</span></div>
        </div>

        <div className='info-box'>
          <p className='label'>Join Date</p>
          <div className='info-content'><CiCalendarDate /><span>25/5/2025</span></div>
        </div>

       
        <div>
          <span className="order-details" onClick={() => toggleDetails(0)}>...</span>
        </div>
          {activeRow === 0 && (
        <table className="details-table container mx-auto" style={{ width: "100%", marginTop: "20px", borderCollapse: "collapse" }}>
          <thead style={{  marginTop: "20px", borderBottom:"1px solid #f6f6f6" }}>
            <tr style={{ color: "#999999", textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Full Name</td>
              <td style={{ padding: "10px" }}>PHONE</td>
              <td style={{ padding: "10px" }}>EMAIL</td>
              <td style={{ padding: "10px" }}>COUNTRY</td>
              <td style={{ padding: "10px" }}>DATE</td>
              <td style={{ padding: "10px" }}>Time</td>
              <td style={{ padding: "10px", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                <IoMdPrint style={{ fontSize: "20px" }} />
                Print
              </td>
            </tr>
          </thead>
          <tbody style={{ backgroundColor: "white", textAlign: "center" , borderBottom:"1px solid #f6f6f6"}}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>Osama Ali alabyaare</td>
              <td style={{ padding: "10px" }}>+20 1012345678</td>
              <td style={{ padding: "10px" }}>osama@email.com</td>
              <td style={{ padding: "10px" }}>Egypt</td>
              <td style={{ padding: "10px" }}>12/12/23</td>
              <td style={{ padding: "10px" }}>12:00 PM</td>
              {/* <td style={{ padding: "10px" }}>12:00 PM</td> */}
            </tr>
          </tbody>

          {/* إذا تريد تكرار نفس الجدول (مثل ما في كودك مرتين) فقط انسخ الـ <thead> و <tbody> مرة ثانية */}
          <thead style={{  marginTop: "20px", borderBottom:"1px solid #f6f6f6" }}>
            <tr style={{ color: "#999999", textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Full Name</td>
              <td style={{ padding: "10px" }}>PHONE</td>
              <td style={{ padding: "10px" }}>EMAIL</td>
              <td style={{ padding: "10px" }}>COUNTRY</td>
              <td style={{ padding: "10px" }}>DATE</td>
              <td style={{ padding: "10px" }}>Time</td>
              <td style={{ padding: "10px" }}>Print</td>
            </tr>
          </thead>
          <tbody style={{ backgroundColor: "white", textAlign: "center" , borderBottom:"1px solid #f6f6f6"}}>
            <tr>
              <td style={{ padding: "10px"}}>Osama Ali alabyaare</td>
              <td style={{ padding: "10px" }}>+20 1012345678</td>
              <td style={{ padding: "10px" }}>osama@email.com</td>
              <td style={{ padding: "10px" }}>Egypt</td>
              <td style={{ padding: "10px" }}>12/12/23</td>
              <td style={{ padding: "10px" }}>12:00 PM</td>
              <td style={{ padding: "10px" }}>12:00 PM</td>
            </tr>
          </tbody>
        </table>
      )}


    {activeRow === 0 && (
  <table className="details-table container mx-auto" style={{ width: "100%", marginTop: "20px", borderCollapse: "collapse" }}>
    <thead> 
      <tr style={{ color: "black", width:"100%" }}>
        <th colSpan={12} style={{ padding: "10px", textAlign: "center" ,backgroundColor:"#f6f6f6"}}>
          Performance
        </th>
      </tr>
    </thead>


       <thead >
            <tr style={{  textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Performance</td>
              <td style={{ padding: "10px" }}>Level</td>
              <td style={{ padding: "10px" }}>Commitment</td>
              <td style={{ padding: "10px" }}>Behavior</td>
              <td style={{ padding: "10px" }}>Evaluation</td>
              <td style={{ padding: "10px" }}>Actions</td>
            
            </tr>
          </thead>
      <tbody style={{ backgroundColor:"#f6f6f6", textAlign: "center" }}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>average</td>
              <td style={{ padding: "10px" }}>admin</td>
              <td style={{ padding: "10px" }}>very good</td>
              <td style={{ padding: "10px" }}>very good

</td>
              <td style={{ padding: "10px" }}><LiaStarSolid  style={{
                color:"yellow"
              }}/>
<LiaStarSolid   style={{
                color:"yellow"
              }}/>
<LiaStarSolid />
<LiaStarSolid /></td>

    <td style={{ padding: "10px" }}><CiEdit style={{
      fontSize:"20px",
      marginRight:"10px"
    }}/>
<MdOutlineDelete    style={{
      fontSize:"20px"
    }}/>

          </td>
             
            </tr>
          </tbody>

      <thead >
            <tr style={{  textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Projects</td>
              <td style={{ padding: "10px" }}>Developments</td>
              <td style={{ padding: "10px" }}>Promotion</td>
              <td style={{ padding: "10px" }}>Notifications</td>
              <td style={{ padding: "10px" }}>Extra time</td>
              <td style={{ padding: "10px" }}>Actions</td>
            
            </tr>
          </thead>
         <tbody style={{ backgroundColor:"#f6f6f6", textAlign: "center" }}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>0</td>
              <td style={{ padding: "10px" }}>0</td>
              <td style={{ padding: "10px" }}>No</td>
              <td style={{ padding: "10px" }}>2

</td>
              <td style={{ padding: "10px" }}>7 H</td>

    <td style={{ padding: "10px" }}><CiEdit style={{
      fontSize:"20px",
      marginRight:"10px"
    }}/>
<MdOutlineDelete    style={{
      fontSize:"20px"
    }}/>

          </td>
             
            </tr>
          </tbody>






           <thead >
            <tr style={{  textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Asbence</td>
              <td style={{ padding: "10px" }}>Delay</td>
              <td style={{ padding: "10px" }}>Permission</td>
              <td style={{ padding: "10px" }}>Deduct</td>
              <td style={{ padding: "10px" }}>Bonus</td>
              <td style={{ padding: "10px" }}>Actions</td>
            
            </tr>
          </thead>
         <tbody style={{ backgroundColor:"#f6f6f6", textAlign: "center" }}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>0</td>
              <td style={{ padding: "10px" }}>0</td>
              <td style={{ padding: "10px" }}>2</td>
              <td style={{ padding: "10px" }}>2

</td>
              <td style={{ padding: "10px" }}>1</td>

    <td style={{ padding: "10px" }}><CiEdit style={{
      fontSize:"20px",
      marginRight:"10px"
    }}/>
<MdOutlineDelete    style={{
      fontSize:"20px"
    }}/>

          </td>
             
            </tr>
          </tbody>
  </table>
)}










      </div>

    
    </div>
  );
}
